export default "__VITE_ASSET__Dy_0$Bm6__"